export default __webpack_public_path__ + "static/media/KOD0097-min.f88dd527.webp";